export default __webpack_public_path__ + "static/media/invoice-icon.ef1c3b21.svg";